import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
let auditSetting_text = class auditSetting_text extends Vue {
  deleteLogic(index) {
    this.$emit("delete");
  }
  ifItemChange(value, index) {
    console.log("ifItemChange", value, index);
    if (value) {
      let oifItemIndex = this.noneDecoItems.findIndex(item => {
        return item.data.id == value;
      });
      if (oifItemIndex >= 0) {
        this.logicItem.ifItemIndex = oifItemIndex;
        this.logicItem.compareItem = "";
      }
    }
  }
  compareItemChange(value, index) {
    console.log("ifItemChange", value, index);
    if (value) {
      let itemindex = this.noneDecoItems.findIndex(item => {
        return item.data.id == value;
      });
      if (itemindex >= 0) {
        this.logicItem.compareItemIndex = itemindex;
      }
    }
  }
  validateIfItem(rule, value, callback) {
    let ifitemExist = this.noneDecoItems.some(nitem => {
      return nitem.data.id == value;
    });
    if (!ifitemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemOptions(rule, value, callback) {
    let ifItemOptions = this.logicItem.ifItemOptions;
    const itemExist = value.every(id => {
      return ifItemOptions.some(op => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemCompareOptions(rule, value, callback) {
    let ifItemOptions = this.logicItem.compareItemOptions;
    const itemExist = value.every(id => {
      return ifItemOptions.some(op => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], auditSetting_text.prototype, "visible", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], auditSetting_text.prototype, "disabled", void 0);
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], auditSetting_text.prototype, "logicItem", void 0);
__decorate([Prop({
  type: Array,
  default() {
    return [];
  }
})], auditSetting_text.prototype, "ifItems", void 0);
__decorate([Prop({
  type: Array,
  default() {
    return [];
  }
})], auditSetting_text.prototype, "noneDecoItems", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], auditSetting_text.prototype, "index", void 0);
auditSetting_text = __decorate([Component({
  name: "auditSetting_text",
  components: {},
  filters: {}
})], auditSetting_text);
export default auditSetting_text;